import { InputConfig } from "@cpj-ai/panel-npm-package";

export const inputConfigs: InputConfig[] = [
  {
    name: "newPassword1",
    previewSize: 12,
    inputProps: {
      type: "password",
      label: "Password:",
      placeholder: "Enter your password",
      showStrengthLevel: true,
    },
    rules: {
      required: "This field is required",
    },
  },
  {
    name: "newPassword2",
    previewSize: 12,
    inputProps: {
      type: "password",
      label: "Return New Password:",
      placeholder: "Enter your password",
      showStrengthLevel: false,
    },
    rules: {
      required: "This field is required",
      validate: (value: string, context: any) => {
        return value === context.newPassword1 || "The passwords do not match.";
      },
    },
  },
];
